import { Piano } from "./piano";
import { Viewport } from "./piano-viewport";
import { Note } from "../music/note";

type KeyColor = 'white' | 'black';

export type KeyLayout = {
  note: Note;
  midi: number;
  color: KeyColor;
  whiteIndex: number;
};

function isBlackMidi(midi: number): boolean {
  const pc = ((midi % 12) + 12) % 12;

  return pc === 1 || pc === 3 || pc === 6 || pc === 8 || pc === 10;
}

export class PianoLayout {
  private keys: KeyLayout[] = [];
  private byMidi = new Map<number, KeyLayout>();
  private whiteCount = 0;

  constructor(
    private readonly piano: Piano,
    private readonly viewport: Viewport
  ) {
    this.recompute();
  }

  recompute(): void {
    this.keys = [];
    this.byMidi.clear();
    this.whiteCount = 0;

    let whiteIndex = 0;

    for (const note of this.viewport.visibleNotes()) {
      const midi = note.toMidi();
      const black = isBlackMidi(midi);

      const attachedWhiteIndex = black ? Math.max(0, whiteIndex - 1) : whiteIndex;

      const key: KeyLayout = {
        note,
        midi,
        color: black ? 'black' : 'white',
        whiteIndex: attachedWhiteIndex,
      };

      this.keys.push(key);
      this.byMidi.set(midi, key);

      if (!black) whiteIndex++;
    }

    this.whiteCount = whiteIndex;
  }

  getKeys(): readonly KeyLayout[] {
    return this.keys;
  }

  getWhiteCount(): number {
    return this.whiteCount;
  }

  getKeyByMidi(midi: number): KeyLayout | undefined {
    return this.byMidi.get(midi);
  }

  getWhiteKeys(): KeyLayout[] {
    return this.keys.filter(k => k.color === 'white');
  }

  getBlackKeys(): KeyLayout[] {
    return this.keys.filter(k => k.color === 'black');
  }
}
